/* ==========================================================================
   Digital G-FORCE — interactions (vanilla JS, no dependencies)
   Every component enhances markup that already works without JavaScript.
   ========================================================================== */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var define = function (name, cls) {
    if (!customElements.get(name)) customElements.define(name, cls);
  };
  var qs = function (sel, root) { return (root || document).querySelector(sel); };
  var qsa = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };
  var store = {
    get: function (k, d) { try { var v = sessionStorage.getItem(k); return v ? JSON.parse(v) : d; } catch (e) { return d; } },
    set: function (k, v) { try { sessionStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }
  };

  /* ---------- Scroll reveal ---------- */
  function initReveal(root) {
    var items = qsa('[data-dgf-reveal]:not(.is-in)', root);
    if (!items.length) return;
    if (reduceMotion || !('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    items.forEach(function (el) { io.observe(el); });
    // Safety net: never leave on-screen content hidden if the observer is slow
    setTimeout(function () {
      items.forEach(function (el) {
        if (el.classList.contains('is-in')) return;
        var r = el.getBoundingClientRect();
        if (r.top < window.innerHeight && r.bottom > 0) el.classList.add('is-in');
      });
    }, 1500);
  }

  /* ---------- Simulator showcase (list <-> markers) ---------- */
  class DgfShowcase extends HTMLElement {
    connectedCallback() {
      this.items = qsa('.dgf-showcase__item', this);
      this.markers = qsa('.dgf-showcase__marker', this);
      if (!this.items.length) return;
      var self = this;
      this.items.forEach(function (item) {
        var btn = qs('.dgf-showcase__item-btn', item);
        var id = item.dataset.id;
        ['mouseenter', 'focusin'].forEach(function (ev) {
          item.addEventListener(ev, function () { self.activate(id); });
        });
        btn.addEventListener('click', function () { self.activate(id); });
      });
      this.markers.forEach(function (m) {
        m.addEventListener('click', function () {
          self.activate(m.dataset.target);
          var target = self.querySelector('[data-id="' + m.dataset.target + '"] .dgf-showcase__item-btn');
          if (target) target.focus({ preventScroll: window.innerWidth >= 990 });
        });
        m.addEventListener('mouseenter', function () { self.activate(m.dataset.target); });
      });
      this.activate(this.items[0].dataset.id);
    }
    activate(id) {
      this.items.forEach(function (i) {
        var on = i.dataset.id === id;
        i.classList.toggle('is-active', on);
        var b = qs('.dgf-showcase__item-btn', i);
        if (b) b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      this.markers.forEach(function (m) { m.classList.toggle('is-active', m.dataset.target === id); });
    }
  }
  define('dgf-showcase', DgfShowcase);

  /* ---------- Product rail ---------- */
  class DgfRail extends HTMLElement {
    connectedCallback() {
      this.track = qs('.dgf-rail__track', this);
      this.nav = qs('.dgf-rail__nav', this);
      if (!this.track || !this.nav) return;
      var self = this;
      qsa('button', this.nav).forEach(function (b) {
        b.addEventListener('click', function () {
          var dir = Number(b.dataset.dir);
          self.track.scrollBy({ left: dir * self.track.clientWidth * 0.85, behavior: reduceMotion ? 'auto' : 'smooth' });
        });
      });
      this.update = this.update.bind(this);
      this.track.addEventListener('scroll', this.update, { passive: true });
      window.addEventListener('resize', this.update);
      this.update();
    }
    update() {
      var t = this.track;
      var overflow = t.scrollWidth > t.clientWidth + 4;
      this.nav.hidden = !overflow;
      var btns = qsa('button', this.nav);
      if (btns.length === 2) {
        btns[0].disabled = t.scrollLeft <= 2;
        btns[1].disabled = t.scrollLeft + t.clientWidth >= t.scrollWidth - 2;
      }
    }
  }
  define('dgf-rail', DgfRail);

  /* ---------- Simulator guide (homepage) ---------- */
  class DgfFinder extends HTMLElement {
    connectedCallback() {
      this.form = qs('form', this);
      this.steps = qsa('.dgf-finder__step', this);
      this.result = qs('.dgf-finder__result', this);
      this.back = qs('.dgf-finder__back', this);
      this.next = qs('.dgf-finder__next', this);
      this.progress = qsa('.dgf-finder__progress li', this);
      this.index = 0;
      if (!this.form || !this.steps.length) return;
      var planner = this.dataset.planner || '/pages/contact';
      this.form.setAttribute('action', planner.split('#')[0] + '#dgf-planner');
      var self = this;
      this.next.addEventListener('click', function () { self.go(self.index + 1); });
      this.back.addEventListener('click', function () { self.go(self.index - 1); });
      this.form.addEventListener('change', function (e) {
        if (e.target.type === 'radio') {
          self.syncNext();
          clearTimeout(self.t);
          self.t = setTimeout(function () { self.go(self.index + 1); }, reduceMotion ? 0 : 260);
        }
      });
      this.go(0);
    }
    answered(i) {
      return !!qs('input:checked', this.steps[i]);
    }
    syncNext() {
      if (this.index < this.steps.length) this.next.disabled = !this.answered(this.index);
    }
    go(i) {
      var total = this.steps.length;
      if (i < 0) return;
      if (i > 0 && i <= total && !this.answered(i - 1)) return;
      this.index = Math.min(i, total);
      this.steps.forEach(function (s, n) { s.classList.toggle('is-active', n === i); });
      var done = this.index === total;
      this.result.hidden = !done;
      this.next.hidden = done;
      this.back.hidden = this.index === 0;
      var self = this;
      this.progress.forEach(function (p, n) { p.classList.toggle('is-active', n <= self.index); });
      if (done) this.showResult();
      else this.syncNext();
      var focusTarget = done ? this.result : qs('input:checked', this.steps[this.index]) || qs('input', this.steps[this.index]);
      if (focusTarget && this.dataset.touched) focusTarget.focus({ preventScroll: true });
      this.dataset.touched = '1';
    }
    showResult() {
      var dl = qs('.dgf-finder__summary', this.result);
      dl.innerHTML = '';
      var browse = qs('.dgf-finder__browse', this.result);
      browse.hidden = true;
      this.steps.forEach(function (s) {
        var legend = qs('legend', s).cloneNode(true);
        var count = qs('.dgf-finder__count', legend);
        if (count) count.remove();
        var checked = qs('input:checked', s);
        if (!checked) return;
        var row = document.createElement('div');
        var dt = document.createElement('dt');
        var dd = document.createElement('dd');
        dt.textContent = legend.textContent.trim();
        dd.textContent = checked.value;
        row.appendChild(dt); row.appendChild(dd);
        dl.appendChild(row);
        if (checked.dataset.link && browse.hidden) {
          browse.href = checked.dataset.link;
          browse.textContent = 'Browse the store';
          browse.hidden = false;
        }
      });
    }
  }
  define('dgf-finder', DgfFinder);

  /* ---------- Contact form + build planner ---------- */
  function initPlanner() {
    var form = qs('#DgfContactForm');
    if (!form) return;
    var steps = qsa('.dgf-planner__step', form);
    var buildSteps = steps;
    var modeBtns = qsa('.dgf-planner__mode', form);
    var modeField = qs('[data-mode-field]', form);
    var back = qs('.dgf-planner__back', form);
    var next = qs('.dgf-planner__next', form);
    var submit = qs('.dgf-planner__submit', form);
    var bar = qs('.dgf-planner__progress-bar', form);
    var label = qs('.dgf-planner__step-label', form);
    var email = qs('#DgfEmail', form);
    var body = qs('#DgfBody', form);
    var mode = 'build';
    var index = 0;
    form.classList.add('is-enhanced');

    function setMode(m, keepStep) {
      mode = m;
      modeBtns.forEach(function (b) { b.setAttribute('aria-selected', b.dataset.mode === m ? 'true' : 'false'); b.tabIndex = b.dataset.mode === m ? 0 : -1; });
      form.classList.toggle('is-message', m === 'message');
      steps.forEach(function (s) {
        if (s.hasAttribute('data-build')) s.disabled = m === 'message';
      });
      var btn = modeBtns.filter(function (b) { return b.dataset.mode === m; })[0];
      if (modeField && btn) modeField.value = btn.textContent.trim();
      if (body) body.required = m === 'message';
      show(m === 'message' ? steps.length - 1 : (keepStep ? index : 0));
    }

    function show(i) {
      index = Math.max(0, Math.min(i, steps.length - 1));
      steps.forEach(function (s, n) { s.classList.toggle('is-active', n === index); });
      var last = index === steps.length - 1;
      var isBuild = mode === 'build';
      back.hidden = !isBuild || index === 0;
      next.hidden = !isBuild || last;
      submit.hidden = isBuild && !last;
      if (isBuild) {
        bar.style.transform = 'scaleX(' + (index + 1) / steps.length + ')';
        label.textContent = 'Step ' + (index + 1) + ' of ' + steps.length + ' · ' + (steps[index].dataset.title || '');
      } else {
        bar.style.transform = 'scaleX(1)';
        label.textContent = '';
      }
    }

    function focusStep() {
      var target = qs('input:not([type=hidden]), textarea', steps[index]);
      if (target) target.focus({ preventScroll: true });
      var top = form.getBoundingClientRect().top;
      if (top < 0) form.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
    }

    modeBtns.forEach(function (b) {
      b.addEventListener('click', function () { setMode(b.dataset.mode); });
      b.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
          var other = modeBtns.filter(function (x) { return x !== b; })[0];
          other.focus(); setMode(other.dataset.mode);
        }
      });
    });
    next.addEventListener('click', function () { show(index + 1); focusStep(); });
    back.addEventListener('click', function () { show(index - 1); focusStep(); });

    form.addEventListener('submit', function (e) {
      var errs = [];
      if (!email.value || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.value)) errs.push(email);
      if (mode === 'message' && body && !body.value.trim()) errs.push(body);
      qsa('[aria-invalid="true"]', form).forEach(function (el) { el.removeAttribute('aria-invalid'); });
      qsa('.dgf-field__error[data-js]', form).forEach(function (el) { el.remove(); });
      if (errs.length) {
        e.preventDefault();
        show(steps.length - 1);
        errs.forEach(function (el) {
          el.setAttribute('aria-invalid', 'true');
          var p = document.createElement('p');
          p.className = 'dgf-field__error';
          p.setAttribute('data-js', '');
          p.id = el.id + '-jserr';
          p.textContent = el === email ? 'Please enter a valid email address.' : 'Please add a short message.';
          el.setAttribute('aria-describedby', p.id);
          el.parentNode.appendChild(p);
        });
        errs[0].focus();
        return;
      }
      submit.disabled = true;
      submit.classList.add('is-loading');
      submit.textContent = 'Sending…';
    });

    // Prefill from URL (?type=&space=&motion=&product=)
    var params = new URLSearchParams(window.location.search);
    var notes = [];
    ['type', 'space', 'motion'].forEach(function (p) {
      var v = params.get(p);
      if (!v) return;
      var match = qsa('input[data-param="' + p + '"]', form).filter(function (i) { return i.value.toLowerCase() === v.toLowerCase(); })[0];
      if (match) match.checked = true;
      else notes.push(p + ': ' + v);
    });
    var notesField = qs('#DgfNotes', form);
    if (notes.length && notesField && !notesField.value) notesField.value = notes.join('\n');
    var product = params.get('product');
    var posted = params.get('contact_posted') || qs('.dgf-status', form);

    if (product && !posted) {
      setMode('message');
      if (body && !body.value) body.value = 'Hi, I am interested in ' + product + '. Could you share more details?';
    } else if (posted && qs('.dgf-status--error', form)) {
      setMode('build');
      show(steps.length - 1);
    } else {
      setMode('build');
      if (params.get('type') || params.get('space') || params.get('motion')) show(0);
    }
  }

  /* ---------- Tabs (product details) ---------- */
  class DgfTabs extends HTMLElement {
    connectedCallback() {
      var list = qs('.dgf-tabs__list', this);
      var panels = qsa('.dgf-tabs__panel', this);
      if (!list || panels.length < 2) { this.classList.add('is-single'); return; }
      var self = this;
      this.buttons = panels.map(function (p, i) {
        var id = p.id.replace('DgfTab-', '');
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'dgf-tabs__tab';
        b.id = 'DgfTabBtn-' + id;
        b.setAttribute('role', 'tab');
        b.setAttribute('aria-controls', p.id);
        b.textContent = p.dataset.title;
        b.addEventListener('click', function () { self.select(i); });
        b.addEventListener('keydown', function (e) {
          var n = null;
          if (e.key === 'ArrowRight') n = (i + 1) % panels.length;
          if (e.key === 'ArrowLeft') n = (i - 1 + panels.length) % panels.length;
          if (e.key === 'Home') n = 0;
          if (e.key === 'End') n = panels.length - 1;
          if (n !== null) { e.preventDefault(); self.select(n); self.buttons[n].focus(); }
        });
        list.appendChild(b);
        return b;
      });
      this.panels = panels;
      list.hidden = false;
      this.classList.add('is-enhanced');
      this.useHash = this.hasAttribute('data-hash');
      this.select(this.indexFromHash(), true);
      if (this.useHash) {
        window.addEventListener('hashchange', function () {
          var n = self.indexFromHash(-1);
          if (n > -1) { self.select(n, true); self.scrollIntoViewIfAbove(); }
        });
      }
    }
    indexFromHash(fallback) {
      var none = fallback === undefined ? 0 : fallback;
      if (!this.useHash || !location.hash) return none;
      var id = 'DgfTab-' + decodeURIComponent(location.hash.slice(1));
      for (var n = 0; n < this.panels.length; n++) { if (this.panels[n].id === id) return n; }
      return none;
    }
    scrollIntoViewIfAbove() {
      var top = this.getBoundingClientRect().top;
      if (top < 0 || top > window.innerHeight * 0.6) this.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
    }
    select(i, fromHash) {
      if (this.useHash && !fromHash && history.replaceState) {
        history.replaceState(null, '', '#' + this.panels[i].id.replace('DgfTab-', ''));
      }
      this.buttons.forEach(function (b, n) {
        b.setAttribute('aria-selected', n === i ? 'true' : 'false');
        b.tabIndex = n === i ? 0 : -1;
      });
      this.panels.forEach(function (p, n) {
        p.hidden = n !== i;
        p.tabIndex = 0;
      });
    }
  }
  define('dgf-tabs', DgfTabs);

  /* ---------- Shop by category ---------- */
  class DgfShop extends HTMLElement {
    connectedCallback() {
      var self = this;
      this.filters = qsa('.dgf-shop__filter', this);
      this.cats = qsa('.dgf-shop__cat', this);
      this.bar = qs('.dgf-shop__filters', this);
      this.classList.add('is-enhanced');
      this.filters.forEach(function (f) {
        f.addEventListener('click', function (e) {
          e.preventDefault();
          var id = f.dataset.filter;
          self.show(id);
          if (history.replaceState) history.replaceState(null, '', id === 'all' ? location.pathname + location.search : '#' + id);
          self.scrollToTop();
        });
      });
      this.trackHeader();
      this.fromHash(true);
      window.addEventListener('hashchange', function () { self.fromHash(false); });
    }
    show(id) {
      var known = id === 'all' || this.cats.some(function (c) { return c.dataset.cat === id; });
      if (!known) id = 'all';
      this.filters.forEach(function (f) {
        var on = f.dataset.filter === id;
        f.classList.toggle('is-active', on);
        if (on) f.setAttribute('aria-current', 'true'); else f.removeAttribute('aria-current');
        var row = f.parentNode;
        if (on && row.scrollWidth > row.clientWidth) {
          var fr = f.getBoundingClientRect(), rr = row.getBoundingClientRect();
          if (fr.left < rr.left || fr.right > rr.right) row.scrollLeft += fr.left - rr.left - 16;
        }
      });
      this.cats.forEach(function (c) { c.hidden = id !== 'all' && c.dataset.cat !== id; });
      this.classList.toggle('is-filtered', id !== 'all');
    }
    fromHash(initial) {
      var h = decodeURIComponent((location.hash || '').slice(1)).toLowerCase();
      if (!h || h === 'all') { this.show('all'); return; }
      var cat = this.cats.filter(function (c) { return c.dataset.cat === h; })[0];
      if (cat) { this.show(h); if (!initial) this.scrollToTop(); else this.scrollToTop(true); return; }
      // A product: find it by handle or by its title (e.g. #gt-80)
      var card = qsa('.dgf-pcard', this).filter(function (a) {
        return (a.dataset.handles || '').indexOf(' ' + h + ' ') > -1;
      })[0];
      if (!card) {
        card = qsa('.dgf-pcard', this).filter(function (a) {
          return (a.dataset.handles || '').indexOf(h) > -1;
        })[0];
      }
      if (!card) { this.show('all'); return; }
      var host = card.closest('.dgf-shop__cat');
      this.show(host.dataset.cat);
      var self = this;
      requestAnimationFrame(function () {
        var top = card.getBoundingClientRect().top + window.scrollY - self.offset() - 24;
        window.scrollTo({ top: top, behavior: reduceMotion || initial ? 'auto' : 'smooth' });
        card.classList.remove('is-target');
        void card.offsetWidth;
        card.classList.add('is-target');
      });
    }
    offset() {
      return (parseFloat(getComputedStyle(this).getPropertyValue('--dgf-shop-top')) || 0) + (this.bar ? this.bar.offsetHeight : 0);
    }
    scrollToTop(instant) {
      var top = this.getBoundingClientRect().top + window.scrollY - (parseFloat(getComputedStyle(this).getPropertyValue('--dgf-shop-top')) || 0) - 8;
      if (window.scrollY > top || instant) window.scrollTo({ top: Math.max(0, top), behavior: reduceMotion || instant ? 'auto' : 'smooth' });
    }
    trackHeader() {
      var self = this;
      var header = qs('.section-header');
      if (!header) return;
      var update = function () {
        var cs = getComputedStyle(header);
        var sticky = cs.position === 'sticky' || cs.position === 'fixed';
        var h = 0;
        if (sticky) { var r = header.getBoundingClientRect(); h = Math.max(0, r.bottom); }
        self.style.setProperty('--dgf-shop-top', h + 'px');
      };
      update();
      window.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
    }
  }
  define('dgf-shop', DgfShop);

  /* ---------- Sticky buy bar ---------- */
  class DgfStickyBuy extends HTMLElement {
    connectedCallback() {
      this.info = qs('product-info') || document;
      this.mainBtn = qs('.product-form__submit[name="add"]', this.info);
      this.addBtn = qs('[data-add]', this);
      if (!this.mainBtn || !('IntersectionObserver' in window)) return;
      var self = this;
      this.hidden = false;
      this.addBtn.addEventListener('click', function () {
        if (self.mainBtn.disabled || self.mainBtn.getAttribute('aria-disabled') === 'true') {
          self.mainBtn.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'center' });
          return;
        }
        self.mainBtn.click();
      });
      var io = new IntersectionObserver(function (entries) {
        var e = entries[0];
        var show = !e.isIntersecting && e.boundingClientRect.top < 0;
        self.classList.toggle('is-visible', show);
        self.setAttribute('aria-hidden', show ? 'false' : 'true');
        qsa('a, button', self).forEach(function (el) { el.tabIndex = show ? 0 : -1; });
        document.body.classList.toggle('dgf-has-sticky-buy', show);
      });
      io.observe(this.mainBtn);
      this.sync = this.sync.bind(this);
      new MutationObserver(this.sync).observe(this.info, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['disabled', 'checked'] });
      this.info.addEventListener('change', function () { setTimeout(self.sync, 50); });
      this.sync();
    }
    sync() {
      var price = qs('[id^="price-"] .price', this.info) || qs('.price', this.info);
      var priceOut = qs('[data-price]', this);
      if (price && priceOut) {
        var sale = price.classList.contains('price--on-sale');
        var item = sale ? qs('.price__sale .price-item--last', price) : qs('.price__regular .price-item--regular', price);
        if (item && item.textContent.trim()) priceOut.textContent = item.textContent.trim();
      }
      var variantOut = qs('[data-variant]', this);
      if (variantOut) {
        var vals = qsa('variant-selects input[type=radio]:checked, variant-selects select', this.info).map(function (el) {
          return el.tagName === 'SELECT' ? el.options[el.selectedIndex].text.trim() : el.value;
        });
        if (vals.length) variantOut.textContent = vals.join(' / ');
      }
      var label = qs('span', this.mainBtn);
      this.addBtn.textContent = (label ? label.textContent : this.mainBtn.textContent).trim();
      this.addBtn.classList.toggle('is-disabled', !!this.mainBtn.disabled);
    }
  }
  define('dgf-sticky-buy', DgfStickyBuy);

  /* ---------- Product comparison ---------- */
  var CMP_KEY = 'dgf-compare';
  var CMP_MAX = 3;
  class DgfCompare extends HTMLElement {
    connectedCallback() {
      var self = this;
      this.list = store.get(CMP_KEY, []);
      this.dialog = qs('dialog', this);
      this.table = qs('[data-table]', this);
      qs('[data-clear]', this).addEventListener('click', function () { self.list = []; self.save(); });
      qs('[data-open]', this).addEventListener('click', function () { self.open(); });
      qs('[data-close]', this).addEventListener('click', function () { self.dialog.close(); });
      this.dialog.addEventListener('click', function (e) { if (e.target === self.dialog) self.dialog.close(); });
      document.addEventListener('change', function (e) {
        var t = e.target;
        if (!t.matches || !t.matches('[data-dgf-compare]')) return;
        var h = t.dataset.dgfCompare;
        if (t.checked) {
          if (self.list.length >= CMP_MAX) {
            t.checked = false;
            self.flash('You can compare up to ' + CMP_MAX + ' products.');
            return;
          }
          if (!self.list.some(function (i) { return i.handle === h; })) self.list.push({ handle: h, title: t.dataset.title });
        } else {
          self.list = self.list.filter(function (i) { return i.handle !== h; });
        }
        self.save();
      });
      var mo = new MutationObserver(function () { clearTimeout(self.mt); self.mt = setTimeout(function () { self.syncBoxes(); }, 80); });
      mo.observe(document.body, { childList: true, subtree: true });
      this.render();
    }
    save() { store.set(CMP_KEY, this.list); this.render(); }
    flash(msg) {
      var c = qs('.dgf-cmp__count', this);
      c.textContent = msg;
      c.classList.add('is-warn');
      var self = this;
      clearTimeout(this.ft);
      this.ft = setTimeout(function () { c.classList.remove('is-warn'); self.render(); }, 2400);
    }
    syncBoxes() {
      var handles = this.list.map(function (i) { return i.handle; });
      qsa('[data-dgf-compare]').forEach(function (b) { b.checked = handles.indexOf(b.dataset.dgfCompare) > -1; });
    }
    render() {
      var self = this;
      this.hidden = this.list.length === 0;
      document.body.classList.toggle('dgf-has-compare', this.list.length > 0);
      var c = qs('.dgf-cmp__count', this);
      c.innerHTML = '<span data-count>' + this.list.length + '</span> of ' + CMP_MAX + ' selected';
      var chips = qs('[data-chips]', this);
      chips.innerHTML = '';
      this.list.forEach(function (item) {
        var li = document.createElement('li');
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'dgf-cmp__chip';
        b.setAttribute('aria-label', 'Remove ' + item.title + ' from comparison');
        b.innerHTML = '<span></span><svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><path d="M6 6l12 12M18 6 6 18"/></svg>';
        b.firstChild.textContent = item.title;
        b.addEventListener('click', function () {
          self.list = self.list.filter(function (i) { return i.handle !== item.handle; });
          self.save();
        });
        li.appendChild(b);
        chips.appendChild(li);
      });
      qs('[data-open]', this).disabled = this.list.length < 2;
      this.syncBoxes();
    }
    open() {
      var self = this;
      if (typeof this.dialog.showModal === 'function') this.dialog.showModal();
      else this.dialog.setAttribute('open', '');
      this.table.innerHTML = '<p class="dgf-cmp__loading">Loading…</p>';
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      Promise.all(this.list.map(function (item) {
        return fetch(root + 'products/' + encodeURIComponent(item.handle) + '?section_id=dgf-compare-data')
          .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            return qs('.dgf-cmp-data', doc);
          })
          .catch(function () { return null; });
      })).then(function (nodes) { self.build(nodes.filter(Boolean)); });
    }
    build(nodes) {
      if (!nodes.length) {
        this.table.innerHTML = '<p class="dgf-cmp__loading">Sorry, the comparison could not be loaded. Please try again.</p>';
        return;
      }
      var rows = [];
      nodes.forEach(function (n) {
        qsa('[data-row]', n).forEach(function (r) { if (rows.indexOf(r.dataset.row) === -1) rows.push(r.dataset.row); });
      });
      var cartAdd = (window.routes && window.routes.cart_add_url) || '/cart/add';
      var t = document.createElement('table');
      t.className = 'dgf-cmp__table';
      var thead = document.createElement('thead');
      var hr = document.createElement('tr');
      hr.appendChild(document.createElement('td'));
      nodes.forEach(function (n) {
        var th = document.createElement('th');
        th.scope = 'col';
        var img = n.dataset.image ? '<img src="' + n.dataset.image + '" alt="" loading="lazy" width="200" height="200">' : '';
        th.innerHTML = '<a class="dgf-cmp__product" href="' + n.dataset.url + '">' + img + '<span></span></a>';
        qs('span', th).textContent = n.dataset.title;
        hr.appendChild(th);
      });
      thead.appendChild(hr);
      t.appendChild(thead);
      var tb = document.createElement('tbody');
      rows.forEach(function (row) {
        var tr = document.createElement('tr');
        var th = document.createElement('th');
        th.scope = 'row';
        th.textContent = row;
        tr.appendChild(th);
        nodes.forEach(function (n) {
          var td = document.createElement('td');
          var cell = qsa('[data-row]', n).filter(function (r) { return r.dataset.row === row; })[0];
          if (cell) td.innerHTML = qs('dd', cell).innerHTML; else td.innerHTML = '<span class="dgf-cmp__na">—</span>';
          tr.appendChild(td);
        });
        tb.appendChild(tr);
      });
      var atr = document.createElement('tr');
      atr.className = 'dgf-cmp__actions';
      atr.appendChild(document.createElement('th'));
      nodes.forEach(function (n) {
        var td = document.createElement('td');
        if (n.dataset.available === 'true') {
          td.innerHTML = '<form method="post" action="' + cartAdd + '"><input type="hidden" name="id" value="' + n.dataset.variant + '"><input type="hidden" name="quantity" value="1"><button class="dgf-btn dgf-btn--primary" type="submit">Add to cart</button></form>';
        }
        td.insertAdjacentHTML('beforeend', '<a class="dgf-link" href="' + n.dataset.url + '">View product</a>');
        atr.appendChild(td);
      });
      tb.appendChild(atr);
      t.appendChild(tb);
      this.table.innerHTML = '';
      this.table.appendChild(t);
    }
  }
  define('dgf-compare', DgfCompare);

  /* ---------- FAQ filter ---------- */
  class DgfFaqFilter extends HTMLElement {
    connectedCallback() {
      var input = qs('[data-filter]', this);
      var items = qsa('[data-q]', this);
      var heads = qsa('[data-group-head]', this);
      var empty = qs('[data-empty]', this);
      if (!input) return;
      input.addEventListener('input', function () {
        var q = input.value.trim().toLowerCase();
        var any = false;
        items.forEach(function (d) {
          var hit = !q || d.textContent.toLowerCase().indexOf(q) > -1;
          d.hidden = !hit;
          if (hit) any = true;
          if (q && hit) d.open = true;
          if (!q) d.open = false;
        });
        heads.forEach(function (h) {
          var gid = h.dataset.groupHead;
          h.hidden = !items.some(function (d) { return d.dataset.group === gid && !d.hidden; });
        });
        empty.hidden = any;
      });
    }
  }
  define('dgf-faq-filter', DgfFaqFilter);


  /* ---------- Header navigation (hover intent, click, keyboard) ---------- */
  class DgfNav extends HTMLElement {
    connectedCallback() {
      var self = this;
      this.items = qsa('.dgf-nav__item.has-panel', this);
      this.pointer = 'mouse';
      this.addEventListener('pointerdown', function (e) { self.pointer = e.pointerType; }, true);
      this.items.forEach(function (item) {
        var toggle = qs('.dgf-nav__toggle', item);
        var link = qs('.dgf-nav__link', item);
        var timer;
        var open = function () {
          clearTimeout(timer);
          self.closeAll(item);
          item.classList.add('is-open');
          toggle.setAttribute('aria-expanded', 'true');
        };
        var close = function (delay) {
          clearTimeout(timer);
          timer = setTimeout(function () {
            item.classList.remove('is-open');
            toggle.setAttribute('aria-expanded', 'false');
          }, delay || 0);
        };
        item._close = close;
        item.addEventListener('pointerenter', function (e) {
          if (e.pointerType !== 'mouse') return;
          clearTimeout(timer);
          timer = setTimeout(open, item.classList.contains('is-open') ? 0 : 60);
        });
        item.addEventListener('pointerleave', function (e) {
          if (e.pointerType !== 'mouse') return;
          close(280);
        });
        toggle.addEventListener('click', function (e) {
          e.preventDefault();
          if (item.classList.contains('is-open')) close(); else open();
        });
        link.addEventListener('click', function (e) {
          // A label-only item (no link of its own) just toggles its panel
          if (!link.hasAttribute('href')) {
            if (self.pointer === 'mouse' || !item.classList.contains('is-open')) open(); else close();
            return;
          }
          // On touch screens the first tap opens the panel, the second follows the link
          if (self.pointer !== 'mouse' && !item.classList.contains('is-open')) {
            e.preventDefault();
            open();
          }
        });
        item.addEventListener('keydown', function (e) {
          if (e.key === 'Escape' && item.classList.contains('is-open')) {
            close();
            toggle.focus();
          }
          if (e.key === 'ArrowDown' && document.activeElement === toggle) {
            e.preventDefault();
            open();
            setTimeout(function () {
              var first = qs('.dgf-nav__panel a', item);
              if (first) first.focus();
            }, 30);
          }
        });
        item.addEventListener('focusout', function (e) {
          if (!item.contains(e.relatedTarget)) close(120);
        });
      });
      document.addEventListener('click', function (e) { if (!self.contains(e.target)) self.closeAll(); });
      window.addEventListener('scroll', function () {
        if (window.scrollY > 0 && self.pointer !== 'mouse') self.closeAll();
      }, { passive: true });
    }
    closeAll(except) {
      this.items.forEach(function (i) {
        if (i === except) return;
        i.classList.remove('is-open');
        var t = qs('.dgf-nav__toggle', i);
        if (t) t.setAttribute('aria-expanded', 'false');
      });
    }
  }
  define('dgf-nav', DgfNav);

  /* ---------- Race-ready simulators (tier selector) ---------- */
  class DgfLineup extends HTMLElement {
    connectedCallback() {
      var self = this;
      this.tabs = qsa('.dgf-tier-tab', this);
      this.panels = qsa('.dgf-tier', this);
      if (this.tabs.length < 2) return;
      qs('.dgf-tiers', this).hidden = false;
      this.classList.add('is-enhanced');
      this.tabs.forEach(function (t, i) {
        t.addEventListener('click', function () { self.select(t.dataset.anchor, true); });
        t.addEventListener('keydown', function (e) {
          var n = null;
          if (e.key === 'ArrowRight') n = (i + 1) % self.tabs.length;
          if (e.key === 'ArrowLeft') n = (i - 1 + self.tabs.length) % self.tabs.length;
          if (n !== null) { e.preventDefault(); self.tabs[n].focus(); self.select(self.tabs[n].dataset.anchor, true); }
        });
      });
      qsa('[data-tier-link]', this).forEach(function (a) {
        a.addEventListener('click', function (e) {
          e.preventDefault();
          self.select(a.dataset.tierLink, true);
          self.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
        });
      });
      var fromHash = function () {
        var h = (location.hash || '').replace('#', '');
        if (h && self.tabs.some(function (t) { return t.dataset.anchor === h; })) {
          self.select(h, false);
          setTimeout(function () { self.scrollIntoView({ block: 'start' }); }, 60);
          return true;
        }
        return false;
      };
      window.addEventListener('hashchange', fromHash);
      if (!fromHash()) {
        var def = this.dataset.default;
        this.select(this.tabs.some(function (t) { return t.dataset.anchor === def; }) ? def : this.tabs[0].dataset.anchor, false);
      }
    }
    select(anchor, updateUrl) {
      this.tabs.forEach(function (t) {
        var on = t.dataset.anchor === anchor;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
      });
      this.panels.forEach(function (p) {
        var on = p.id === anchor;
        p.classList.toggle('is-active', on);
        p.hidden = !on;
      });
      if (updateUrl && history.replaceState) history.replaceState(null, '', '#' + anchor);
    }
  }
  define('dgf-lineup', DgfLineup);

  /* ---------- Scroll story ---------- */
  class DgfScrollStory extends HTMLElement {
    connectedCallback() {
      var self = this;
      this.chapters = qsa('.dgf-sstory__chapter', this);
      this.slides = qsa('.dgf-sstory__slide', this);
      this.count = qs('[data-current]', this);
      this.bar = qs('.dgf-sstory__bar', this);
      if (!this.chapters.length || !('IntersectionObserver' in window)) return;
      this.classList.add('is-enhanced');
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) self.activate(Number(e.target.dataset.index));
        });
      }, { rootMargin: '-45% 0px -45% 0px', threshold: 0 });
      this.chapters.forEach(function (c) { io.observe(c); });
      this.activate(0);
    }
    activate(i) {
      this.chapters.forEach(function (c, n) { c.classList.toggle('is-active', n === i); });
      this.slides.forEach(function (s, n) { s.classList.toggle('is-active', n === i); });
      if (this.count) this.count.textContent = ('0' + (i + 1)).slice(-2);
      if (this.bar) this.bar.style.transform = 'scaleX(' + (i + 1) / this.chapters.length + ')';
    }
  }
  define('dgf-scroll-story', DgfScrollStory);

  /* ---------- Hero parallax (desktop pointer only) ---------- */
  function initParallax() {
    if (reduceMotion || !window.matchMedia('(pointer: fine)').matches) return;
    qsa('[data-dgf-parallax]').forEach(function (el) {
      var host = el.closest('section') || el;
      var raf;
      host.addEventListener('pointermove', function (e) {
        var r = host.getBoundingClientRect();
        var x = (e.clientX - r.left) / r.width - 0.5;
        var y = (e.clientY - r.top) / r.height - 0.5;
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(function () {
          el.style.setProperty('--px', (x * -14).toFixed(1) + 'px');
          el.style.setProperty('--py', (y * -10).toFixed(1) + 'px');
        });
      });
      host.addEventListener('pointerleave', function () {
        el.style.setProperty('--px', '0px');
        el.style.setProperty('--py', '0px');
      });
    });
  }

  /* ---------- Return navigation: trail, scroll positions, back links ---------- */
  var TRAIL = 'dgf-trail', POS = 'dgf-pos', RESTORE = 'dgf-restore';
  function here() { return location.pathname + location.search; }
  function cleanUrl(u) {
    try { var x = new URL(u, location.origin); return x.pathname + x.search; } catch (e) { return u; }
  }
  function recordPage() {
    var b = document.body;
    var trail = store.get(TRAIL, []);
    var url = here();
    if (!trail.length || trail[trail.length - 1].url !== url) {
      trail.push({ url: url, type: b.dataset.pageType || '', label: b.dataset.dgfLabel || document.title });
    }
    while (trail.length > 15) trail.shift();
    store.set(TRAIL, trail);
  }
  function syncTrail() {
    // Filters, sorting and paging update the URL without a page load.
    var trail = store.get(TRAIL, []);
    var last = trail[trail.length - 1];
    if (last && last.url.split('?')[0] === location.pathname && last.url !== here()) {
      last.url = here();
      store.set(TRAIL, trail);
    }
  }
  function savePosition() {
    syncTrail();
    var pos = store.get(POS, {});
    pos[here()] = Math.round(window.scrollY);
    store.set(POS, pos);
  }
  function previous(type) {
    var trail = store.get(TRAIL, []);
    var url = here();
    for (var i = trail.length - 1; i >= 0; i--) {
      var t = trail[i];
      if (t.url === url) continue;
      if (type === 'any' || t.type === type) return t;
    }
    return null;
  }
  function restorePosition() {
    var target = store.get(RESTORE, null);
    if (!target || target !== here()) return;
    store.set(RESTORE, null);
    var y = store.get(POS, {})[here()];
    if (!y) return;
    if ('scrollRestoration' in history) history.scrollRestoration = 'manual';
    // Images, fonts and animated sections can change the page height while it
    // loads, so keep holding the position for a short window after load.
    // Browser scroll anchoring is paused meanwhile (it would shift the page).
    // Stops the moment the shopper scrolls, taps or presses a key.
    var root = document.documentElement;
    var stopped = false, timer = null, until = Date.now() + 3000;
    var finish = function () {
      stopped = true;
      clearTimeout(timer);
      root.style.overflowAnchor = '';
    };
    ['wheel', 'touchstart', 'keydown', 'mousedown'].forEach(function (ev) {
      window.addEventListener(ev, finish, { once: true, passive: true });
    });
    root.style.overflowAnchor = 'none';
    var go = function () {
      if (stopped) return;
      if (Math.abs(window.scrollY - y) > 1) window.scrollTo(0, y);
      if (Date.now() < until) timer = setTimeout(go, 100);
      else finish();
    };
    go();
    window.addEventListener('load', function () { until = Math.max(until, Date.now() + 1500); }, { once: true });
  }
  function initBackLinks() {
    qsa('[data-dgf-back]').forEach(function (a) {
      var type = a.dataset.dgfBack;
      var prev = previous(type) || (type !== 'any' ? previous('any') : null);
      if (!prev) return;
      a.href = prev.url;
      a.setAttribute('data-dgf-restore', '');
      var label = qs('[data-label]', a);
      if (label) label.textContent = prev.label;
      a.hidden = false;
    });
    // Product breadcrumbs: use the collection page the shopper actually came from
    qsa('[data-dgf-crumbs]').forEach(function (nav) {
      var prev = previous('collection');
      var li = qs('[data-crumb-collection]', nav);
      if (!prev || !li) return;
      // The all-products page is already the "Shop" crumb
      if (prev.url.split('?')[0].replace(/\/$/, '') === '/collections/all') { li.hidden = true; return; }
      var a = qs('a', li);
      a.href = prev.url;
      a.textContent = prev.label;
      li.hidden = false;
    });
  }
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[data-dgf-restore]');
    if (!a || e.metaKey || e.ctrlKey || e.shiftKey || e.button > 0) return;
    var target = cleanUrl(a.getAttribute('href'));
    // If the target is the page we just came from, go back in history:
    // the browser then restores filters, scroll position and loaded state.
    try {
      if (document.referrer) {
        var ref = new URL(document.referrer);
        if (ref.origin === location.origin && ref.pathname + ref.search === target && history.length > 1) {
          e.preventDefault();
          // If the browser reloads the page instead of using its cache,
          // the saved position is applied on arrival.
          store.set(RESTORE, target);
          history.back();
          return;
        }
      }
    } catch (err) {}
    store.set(RESTORE, target);
  });
  var posTimer;
  window.addEventListener('scroll', function () {
    clearTimeout(posTimer);
    posTimer = setTimeout(savePosition, 150);
  }, { passive: true });
  window.addEventListener('pagehide', savePosition);

  /* ---------- External links always open in a new tab ---------- */
  function initExternalLinks(root) {
    qsa('a[href^="http"]', root).forEach(function (a) {
      try {
        var u = new URL(a.href);
        if (u.hostname === location.hostname) return;
        if (/(^|\.)(myshopify\.com|shopify\.com)$/.test(u.hostname) && /checkout|account|login/.test(u.pathname)) return;
        a.target = '_blank';
        var rel = (a.getAttribute('rel') || '').split(' ');
        if (rel.indexOf('noopener') === -1) rel.push('noopener');
        a.setAttribute('rel', rel.join(' ').trim());
      } catch (e) {}
    });
  }

  /* ---------- Home page section links ---------- */
  // Header links that scroll to sections on the home page. Links whose
  // section is hidden or missing are removed, the current section is
  // highlighted while scrolling, and the mobile drawer closes on tap.
  function initHomeNav() {
    var links = qsa('[data-dgf-home-link]');
    if (!links.length) return;
    var root = document.documentElement;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
    var headerEl = qs('.section-header');

    var offset = function () {
      var h = headerEl ? headerEl.getBoundingClientRect().height : 72;
      return Math.round(h + 12);
    };
    var setPadding = function () { root.style.scrollPaddingTop = offset() + 'px'; };
    setPadding();
    window.addEventListener('resize', setPadding, { passive: true });

    var targetFor = function (a) {
      var href = a.getAttribute('href') || '';
      var i = href.indexOf('#');
      if (i === -1) return null;
      var path = href.slice(0, i);
      if (path && path !== '/' && path !== location.pathname) return null;
      var id = decodeURIComponent(href.slice(i + 1));
      return id ? document.getElementById(id) : null;
    };

    var items = [];
    links.forEach(function (a) {
      var href = a.getAttribute('href') || '';
      if (href.indexOf('#') === -1) return; // a normal page link: leave it alone
      var t = targetFor(a);
      if (!t) {
        var li = a.closest('li');
        if (li) li.remove();
        return;
      }
      items.push({ a: a, t: t });
      a.addEventListener('click', function (e) {
        if (e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1) return;
        e.preventDefault();
        var drawer = a.closest('header-drawer');
        var go = function () {
          var y = t.getBoundingClientRect().top + window.scrollY - offset();
          window.scrollTo({ top: Math.max(0, y), behavior: reduce.matches ? 'auto' : 'smooth' });
          if (history.replaceState) history.replaceState(null, '', '#' + t.id);
        };
        if (drawer && typeof drawer.closeMenuDrawer === 'function') {
          drawer.closeMenuDrawer(e);
          setTimeout(go, 60);
        } else {
          go();
        }
      });
    });
    if (!items.length) return;

    // Unique targets in page order
    var targets = [];
    items.forEach(function (it) { if (targets.indexOf(it.t) === -1) targets.push(it.t); });
    targets.sort(function (a, b) {
      return a.compareDocumentPosition(b) & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : 1;
    });

    var current = null;
    var list = qs('.dgf-home-nav .dgf-nav__list');
    var update = function () {
      var line = offset() + window.innerHeight * 0.3;
      var active = null;
      for (var i = 0; i < targets.length; i++) {
        if (targets[i].getBoundingClientRect().top <= line) active = targets[i];
      }
      // At the very bottom, the last section is the current one
      if (window.innerHeight + window.scrollY >= document.documentElement.scrollHeight - 4) {
        active = targets[targets.length - 1];
      }
      if (active === current) return;
      current = active;
      items.forEach(function (it) {
        var on = it.t === active;
        it.a.classList.toggle('is-active', on);
        if (on) it.a.setAttribute('aria-current', 'true');
        else it.a.removeAttribute('aria-current');
        // Keep the active link visible when the link row scrolls sideways
        if (on && list && list.contains(it.a) && list.scrollWidth > list.clientWidth) {
          var l = it.a.offsetLeft, r = l + it.a.offsetWidth;
          if (l < list.scrollLeft || r > list.scrollLeft + list.clientWidth) {
            list.scrollTo({ left: l - 16, behavior: reduce.matches ? 'auto' : 'smooth' });
          }
        }
      });
    };
    var ticking = false;
    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () { ticking = false; update(); });
    }, { passive: true });
    window.addEventListener('resize', update, { passive: true });
    update();
  }

  /* ---------- Boot ---------- */
  function boot() {
    recordPage();
    restorePosition();
    initReveal(document);
    initPlanner();
    initBackLinks();
    initExternalLinks(document);
    initParallax();
    initHomeNav();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  // Theme editor: re-run when sections are added or changed
  document.addEventListener('shopify:section:load', function (e) {
    initReveal(e.target);
    initExternalLinks(e.target);
    if (qs('#DgfContactForm', e.target)) initPlanner();
  });
})();
